<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <!-- gofix-default-table -->
                        <gofix-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @new-item="openModalAddressBook"
                            @row-click="openModalAddressBook"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                        </gofix-table>
                    </gofix-card>

                    <b-modal :no-close-on-backdrop="true"
                        id="modal-Create"
                        :title="modals.addressBook.title" hide-footer :centered="true"
                        v-model="modals.addressBook.open">
                        <b-form class="pb-20">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-dropdown
                                        label="Client Contract"
                                        vLabel="contract_name"
                                        :filterable="false"
                                        :append-to-body="true"
                                        :required="true"
                                        :show-icon-required="true"
                                        :reduce="option => option.id"
                                        :options="modals.addressBook.options.contracts"
                                        @search="searchContract"
                                        v-model="modals.addressBook.data.contract_id">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input label="Email" :required="true" :show-icon-required="true" v-model="modals.addressBook.data.email"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input label="First Name" :required="true" :show-icon-required="true" v-model="modals.addressBook.data.first_name"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input label="Last Name" :required="true" :show-icon-required="true" v-model="modals.addressBook.data.last_name"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input-number
                                        label="Phone Number"
                                        v-model="modals.addressBook.data.primary_phone"
                                        :integer-limit="15"
                                        :include-thousands-separator="false"
                                        :allowDecimal="false">
                                    </gofix-form-input-number>
                                </b-col>
                            </b-row>
                        </b-form>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SAVE" @click="save" :disabled="modals.addressBook.loading" noBorder></gofix-button>
                    </b-button-group>
                </b-modal>
                </b-col>
            </b-row>
        </div>
    </div>
    <!-- <div class="animated userDutyPage fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 clientStaffTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="fm_officers"
                        arrows >
                    <template slot="gofixTab:fm_officers">
                        <gofix-split>
                            <template slot="gofixSplit:left">
                                <gofix-card fullContent class="allUser" classHeader="m-0" classContent="m-0">
                                    <h3 class="allUserItem" v-bind:class="{active : !userGroups.active}" @click="changeGroupID(null)">ALL Users</h3>
                                </gofix-card>
                                <gofix-card fullContent title="FM Team" classHeader="pl-20" class="groupUser">
                                    <template slot="gofixCard:right_header">
                                        <div class="d-flex justify-content-end align-items-center">
                                            <span @click="openGroupModal(1)" class="mr-2 cursor-pointer" title="Create FM team" v-b-tooltip.hover>
                                                <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.526 4.91855L10.1127 0.505273C9.98965 0.382227 9.82353 0.3125 9.64922 0.3125H0.9375C0.574512 0.3125 0.28125 0.605762 0.28125 0.96875V18.0312C0.28125 18.3942 0.574512 18.6875 0.9375 18.6875H14.0625C14.4255 18.6875 14.7188 18.3942 14.7188 18.0312V5.38408C14.7188 5.20977 14.649 5.0416 14.526 4.91855ZM13.2053 5.68555H9.3457V1.82598L13.2053 5.68555ZM13.2422 17.2109H1.75781V1.78906H7.95117V6.21875C7.95117 6.44719 8.04192 6.66627 8.20345 6.8278C8.36498 6.98933 8.58406 7.08008 8.8125 7.08008H13.2422V17.2109ZM8.15625 8.67969C8.15625 8.58945 8.08242 8.51562 7.99219 8.51562H7.00781C6.91758 8.51562 6.84375 8.58945 6.84375 8.67969V10.8945H4.62891C4.53867 10.8945 4.46484 10.9684 4.46484 11.0586V12.043C4.46484 12.1332 4.53867 12.207 4.62891 12.207H6.84375V14.4219C6.84375 14.5121 6.91758 14.5859 7.00781 14.5859H7.99219C8.08242 14.5859 8.15625 14.5121 8.15625 14.4219V12.207H10.3711C10.4613 12.207 10.5352 12.1332 10.5352 12.043V11.0586C10.5352 10.9684 10.4613 10.8945 10.3711 10.8945H8.15625V8.67969Z" fill="#999999"/>
                                                </svg>
                                            </span>
                                            <span @click="openDeleteGroupModal" v-if="userGroups.active" class="cursor-pointer" title="Delete FM team" v-b-tooltip.hover>
                                                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.5 4.5H16.5" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M5.66699 4.49984V2.83317C5.66699 2.39114 5.84259 1.96722 6.15515 1.65466C6.46771 1.3421 6.89163 1.1665 7.33366 1.1665H10.667C11.109 1.1665 11.5329 1.3421 11.8455 1.65466C12.1581 1.96722 12.3337 2.39114 12.3337 2.83317V4.49984M14.8337 4.49984V16.1665C14.8337 16.6085 14.6581 17.0325 14.3455 17.345C14.0329 17.6576 13.609 17.8332 13.167 17.8332H4.83366C4.39163 17.8332 3.96771 17.6576 3.65515 17.345C3.34259 17.0325 3.16699 16.6085 3.16699 16.1665V4.49984H14.8337Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.33301 8.6665V13.6665" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10.667 8.6665V13.6665" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </template>
                                    <gofix-form-input label="Search" v-model="search"></gofix-form-input>
                                    <ul class="fmTeamItems">
                                        <li class="fmTeamItem" @click="changeGroupID(usergroup.id)" v-bind:class="{active :usergroup.id === userGroups.active}" v-for="usergroup in filteredItems">
                                            <span class="name">{{usergroup.group_name}}</span>
                                            <span class="action" v-on:click.stop="openGroupModal(usergroup)">
                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.709 3.63102C18.099 4.02102 18.099 4.65102 17.709 5.04102L15.879 6.87102L12.129 3.12102L13.959 1.29102C14.1459 1.10377 14.3995 0.998535 14.664 0.998535C14.9285 0.998535 15.1822 1.10377 15.369 1.29102L17.709 3.63102ZM-0.000976562 18.501V15.461C-0.000976562 15.321 0.0490234 15.201 0.149023 15.101L11.059 4.19102L14.809 7.94102L3.88902 18.851C3.79902 18.951 3.66902 19.001 3.53902 19.001H0.499023C0.219023 19.001 -0.000976562 18.781 -0.000976562 18.501Z" fill="#999999"/>
                                                </svg>
                                            </span>
                                        </li>
                                    </ul>
                                </gofix-card>
                            </template>
                            <template slot="gofixSplit:right">
                                <gofix-card fullContent class="mb-0">
                                    <gofix-default-table
                                            class="scrollRightArea"
                                            :settings="tableConfig"
                                            :table-items="tableItems"
                                            @load-items="getTableData"
                                            @new-item="openCreateItem"
                                            @row-click="openCreateItem"
                                            @delete-items="deleteItems"
                                            ref="gofixTable">
                                        <template slot="gofix_table:after-control-left-selected">
                                            <li class="control-item">
                                                <a class="control-item-link cursor-pointer" @click="openAssignGroupModal" title="Add user to team" v-b-tooltip.hover>
                                                    <img class="h-21" src="img/add-team.png" alt="Add user to team">
                                                </a>
                                            </li>
                                            <li class="control-item" v-if="userGroups.active">
                                                <a class="control-item-link cursor-pointer" @click="openRemoveUserFromGroupModal" title="Remove user from team" v-b-tooltip.hover>
                                                    <img class="h-21" src="img/remove-team.png" alt="Remove user from team">
                                                </a>
                                            </li>
                                        </template>
                                        <template slot="gofix_table:active" slot-scope="row">
                                            <span class="text-highlight">{{ row.item.active ? "Active" : "Inactive" }}</span>
                                        </template>
                                        <template slot="gofix_table:start_date" slot-scope="row">
                                            {{ row.item.start_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                                        </template>
                                        <template slot="gofix_table:user_teams" slot-scope="row">
                                            {{ row.item.user_teams ? row.item.user_teams.replaceAll(",", ", ") : '' }}
                                        </template>
                                        <template slot="gofix_table:end_date" slot-scope="row">
                                            {{ row.item.end_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                                        </template>
                                    </gofix-default-table>
                                </gofix-card>
                            </template>
                        </gofix-split>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.create.title" hide-footer :centered="true"
                 v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Select by Name or Email"
                                desc="Search by name or email"
                                @search="searchUser"
                                @change="selectUser"
                                :filterable="false"
                                :required="true"
                                :disabled="!!modals.create.data.id"
                                v-model="officerName"
                                :options="modals.create.users.data">
                            <template #gofixInput:dropdown:option="{ name, email }">
                                {{name}} - {{email}}
                            </template>
                            <template #gofixInput:dropdown:selected-option="{ name, email }">
                                {{name}} - {{email}}
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Role"
                                vLabel="name"
                                :filterable="false"
                                :multiple="!modals.create.data.id"
                                :required="true"
                                :reduce="option => option.id"
                                v-model="modals.create.data.role_id"
                                :options="modals.create.roles">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-properties
                                label="Property"
                                :contract-id="$route.params.id"
                                :property-id="ClientContractID ? ClientContractID.property_root_id : null"
                                v-model="modals.create.data.property"
                                valueFormat="object"
                                required>
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-tree
                            label="Service Category"
                            :default-expand-level="1"
                            :multiple="false"
                            :options="modals.create.service_categorys"
                            :load-options="loadOptionServices"
                            :normalizer="normalizer"
                            search-nested
                            valueFormat="object"
                            v-model="modals.create.data.service_category"
                            placeholder="Select"
                            ref="input">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="start_date"
                                label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="end_date"
                                label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="FM Team"
                            vLabel="group_name"
                            :filterable="false"
                            :multiple="true"
                            :required="true"
                            :clearable="false"
                            v-model="modals.create.data.groups"
                            :options="userGroups.items">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="ADD NEW USER" :dark="true" class="text-light-back" @click="addNewUser" noBorder></gofix-button>
                <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.group.title" hide-footer :centered="true"
                 v-model="modals.group.open">
            <b-form class="pb-20">
                <gofix-form-input label="Team Name" v-model="modals.group.data.group_name" required></gofix-form-input>
                <gofix-form-input-textarea label="Description" :rows="5"  v-model="modals.group.data.description"></gofix-form-input-textarea>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveUserGroup" :loading="modals.group.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.assign.title" hide-footer :centered="true"
                 v-model="modals.assign.open">
            <b-form class="pb-20">
                <gofix-form-dropdown
                    label="FM Team"
                    vLabel="group_name"
                    :reduce="option => option.id"
                    :filterable="false"
                    :clearable="false"
                    v-model="modals.assign.data.group_id"
                    :options="userGroups.items">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="assignUserToGroup" :loading="modals.assign.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove user from group" hide-footer hide-header :centered="true" v-model="modals.remove.open">
            <div class="center">Are you sure you want to<br/>remove <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.remove.open = false">No</b-button>
                <b-button class="custom-btn" @click="removeUserFromGroup" :disabled="modals.remove.loading">
                    <b-spinner v-if="modals.remove.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove user from group" hide-footer hide-header :centered="true" v-model="modals.removeGroup.open">
            <div class="center">Are you sure you want to<br/>remove <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.removeGroup.open = false">No</b-button>
                <b-button class="custom-btn" @click="removeGroup" :disabled="modals.removeGroup.loading">
                    <b-spinner v-if="modals.removeGroup.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
    </div> -->
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    export default {
        name: 'nlt-address-book',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['nlt_address_book']));
            return {
                tableConfig:{
                    name: 'case-address-book',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-center',
                                tdClass: 'checkbox-column text-center',
                                width: 50,
                                thStyle: "width:50px",
                            },
                            {
                                key: 'id',
                                label: 'ID',
                                isActive: 1,
                                isFilter: true,
                                with:100,
                                thStyle: "width:100px",
                                sorting: true,
                            },
                            {
                                key: 'display_name',
                                label: 'Name',
                                isActive: 1,
                                isFilter: true,
                                with:350,
                                thStyle: "width:350px",
                                sorting: true,
                            },
                            {
                                key: 'email',
                                label: 'Email',
                                isActive: 1,
                                isFilter: true,
                                with:300,
                                thStyle: "width:300px",
                                sorting: true,
                            },
                            {
                                key: 'primary_phone',
                                label: 'Phone Number',
                                thClass: 'th-auto',
                                isActive: 1,
                                isFilter: true,
                                sorting: true,
                            }
                    ]
                },
                tableItems: [],
                modals:{
                    addressBook:{
                        open: false,
                        loading: false,
                        title:"Add Address Book",
                        data:{
                            id: null,
                            email: null,
                            primary_phone: null,
                            first_name: null,
                            last_name: null,
                            contract_id: null
                        },
                        options: {
                            contracts: []
                        }
                    }
                },
                timer: {
                    save: null,
                    contracts: null
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {},
        created() {
            this.getContracts()
        },
        methods:{
            /*-- Gofix Table --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                // let response = {
                //     items: [
                //         {
                //             id: 1,
                //             contact_name: "NLT",
                //             email: "quangvinh@pixelcent.com",
                //             primary_phone: "0329293444",
                //             display_name: "Dwayne Johnson",
                //             client_contract_id: 749
                //         },
                //          {
                //             id: 2,
                //             contact_name: "NLT",
                //             email: "qvinh121998@gmail.com",
                //             primary_phone: "0329293443",
                //             display_name: "Johnson",
                //             client_contract_id: 749
                //         }
                //     ],
                //     total: 2
                // }
                // this.tableItems = response.items;
                // this.tableConfig.total = response.total;
                // resolve(response);
                // return
                await this.$store.dispatch("NLTAddressBookController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("NLTAddressBookController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'nlt_address_book'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },

            /*-- Validation Data --------*/
            emailValidationCheckFormat(email_address){
                if(email_address && email_address != ''){
                    let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                    let result = pattern.test(email_address);
                    return result;
                }
                return true;
            },

            /*-- Store Data --------*/
            openModalAddressBook(item){
                this.modals.addressBook.open = true;
                if(item){
                    this.modals.addressBook.title = "Edit Address Book";
                    this.modals.addressBook.data = {
                        id: item.id,
                        contact_name: item.contact_name,
                        email: item.email,
                        primary_phone: item.primary_phone,
                        // display_name: item.display_name,
                        first_name: item.first_name,
                        last_name: item.last_name,
                        contract_id: item.contract_id
                    };
                }else{
                    this.modals.addressBook.title = "Add Address Book";
                    this.modals.addressBook.data = {
                        id: null,
                        contact_name: "NLT",
                        email: null,
                        primary_phone: null,
                        first_name: null,
                        last_name: null,
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null
                    };
                }
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(() => {
                    if(!this.modals.addressBook.data.contract_id) return this.$alertNotification("Client contract is required.", "danger");
                    if(!this.modals.addressBook.data.email) return this.$alertNotification("Email is required.", "danger");
                    if(!this.modals.addressBook.data.first_name) return this.$alertNotification("First Name is required.", "danger");
                    if(!this.modals.addressBook.data.last_name) return this.$alertNotification("Last Name is required.", "danger");
                    
                    if(!this.emailValidationCheckFormat(this.modals.addressBook.data.email)) {
                        return this.$alertNotification("Email is not in a correct format.", "danger");
                    }

                    if(this.modals.addressBook.loading) return;
                    this.modals.addressBook.loading = true;
                    let request = JSON.parse(JSON.stringify(this.modals.addressBook.data));
                    // request.display_name = `${request.first_name} ${request.last_name}`
                    let action = 'createItem';
                    let keyMsg = 'adding'
                    if(request.id){
                        action = 'updateItem';
                        keyMsg = 'editing'
                    }
                    this.$store.dispatch(`NLTAddressBookController/${action}`, request)
                        .then(result => {
                            this.modals.addressBook.loading = false;
                            this.modals.addressBook.open = false;
                            this.$alertNotification(this.$notificationV2(keyMsg, 'nlt_address_book'));
                            this.$refs.gofixTable.reloadTableKeepFilter();
                        })
                        .catch(error => {
                            console.log(error)
                            this.modals.addressBook.loading = false;
                            if(error.response) this.$alertNotification(error.response.data.error.message.error, "danger");
                        })
                }, 300);
                
            },

            /*-- Get Data --------*/
            async getContracts(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.modals.addressBook.options.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.modals.addressBook.options.contracts = []
                loading(true);
                if(this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
        }
    }
</script>